import React from 'react';

const EditUserModal = ({
  isOpen,
  onClose,
  loading,
  errors,
  form,
  onChange,
  onSubmit,
  schools,
}) => {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0,0,0,0.45)',
        zIndex: 1002,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px'
      }}
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div style={{
        width: '100%',
        maxWidth: '720px',
        backgroundColor: 'white',
        borderRadius: '16px',
        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)',
        overflow: 'hidden'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '16px 18px',
          borderBottom: '1px solid #e5e7eb'
        }}>
          <div style={{
            fontFamily: '"Baikal Book"',
            fontSize: '16px',
            fontWeight: 900,
            color: '#111827'
          }}>
            Edit User
          </div>
          <button
            onClick={onClose}
            disabled={loading}
            style={{
              background: 'transparent',
              border: 'none',
              cursor: loading ? 'not-allowed' : 'pointer',
              fontSize: '20px',
              lineHeight: 1,
              padding: '6px 8px',
              borderRadius: '8px',
              color: '#111827',
              opacity: loading ? 0.6 : 1
            }}
          >
            ×
          </button>
        </div>

        <form onSubmit={onSubmit} style={{ padding: '18px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
            <div>
              <label style={{ display: 'block', fontSize: '13px', fontFamily: '"Baikal Book"', fontWeight: 700, marginBottom: '6px' }}>
                First name
              </label>
              <input
                name="first_name"
                value={form.first_name}
                onChange={onChange}
                style={{
                  width: '100%',
                  padding: '12px 12px',
                  border: `1px solid ${errors.first_name ? '#ef4444' : '#e5e7eb'}`,
                  borderRadius: '10px',
                  fontFamily: '"Baikal Book"',
                  fontSize: '14px'
                }}
              />
              {errors.first_name && (
                <div style={{ marginTop: '6px', color: '#ef4444', fontSize: '12px', fontFamily: '"Baikal Book"' }}>
                  {Array.isArray(errors.first_name) ? errors.first_name.join(', ') : errors.first_name}
                </div>
              )}
            </div>

            <div>
              <label style={{ display: 'block', fontSize: '13px', fontFamily: '"Baikal Book"', fontWeight: 700, marginBottom: '6px' }}>
                Last name
              </label>
              <input
                name="last_name"
                value={form.last_name}
                onChange={onChange}
                style={{
                  width: '100%',
                  padding: '12px 12px',
                  border: `1px solid ${errors.last_name ? '#ef4444' : '#e5e7eb'}`,
                  borderRadius: '10px',
                  fontFamily: '"Baikal Book"',
                  fontSize: '14px'
                }}
              />
              {errors.last_name && (
                <div style={{ marginTop: '6px', color: '#ef4444', fontSize: '12px', fontFamily: '"Baikal Book"' }}>
                  {Array.isArray(errors.last_name) ? errors.last_name.join(', ') : errors.last_name}
                </div>
              )}
            </div>

            <div style={{ gridColumn: '1 / -1' }}>
              <label style={{ display: 'block', fontSize: '13px', fontFamily: '"Baikal Book"', fontWeight: 700, marginBottom: '6px' }}>
                Email
              </label>
              <input
                name="email"
                type="email"
                value={form.email}
                onChange={onChange}
                style={{
                  width: '100%',
                  padding: '12px 12px',
                  border: `1px solid ${errors.email ? '#ef4444' : '#e5e7eb'}`,
                  borderRadius: '10px',
                  fontFamily: '"Baikal Book"',
                  fontSize: '14px'
                }}
              />
              {errors.email && (
                <div style={{ marginTop: '6px', color: '#ef4444', fontSize: '12px', fontFamily: '"Baikal Book"' }}>
                  {Array.isArray(errors.email) ? errors.email.join(', ') : errors.email}
                </div>
              )}
            </div>

            <div>
              <label style={{ display: 'block', fontSize: '13px', fontFamily: '"Baikal Book"', fontWeight: 700, marginBottom: '6px' }}>
                Role
              </label>
              <select
                name="role"
                value={form.role}
                onChange={onChange}
                style={{
                  width: '100%',
                  padding: '12px 12px',
                  border: '1px solid #e5e7eb',
                  borderRadius: '10px',
                  fontFamily: '"Baikal Book"',
                  fontSize: '14px',
                  backgroundColor: 'white'
                }}
              >
                <option value="user">User</option>
                <option value="embed_tester">Embed Tester</option>
                <option value="merchant_specialist">Merchant Specialist</option>
                <option value="staff">Staff</option>
                <option value="superuser">Superuser</option>
              </select>
            </div>

            {form.role !== 'merchant_specialist' && (
            <div>
              <label style={{ display: 'block', fontSize: '13px', fontFamily: '"Baikal Book"', fontWeight: 700, marginBottom: '6px' }}>
                School (optional)
              </label>
              <select
                name="active_school"
                value={form.active_school}
                onChange={onChange}
                style={{
                  width: '100%',
                  padding: '12px 12px',
                  border: '1px solid #e5e7eb',
                  borderRadius: '10px',
                  fontFamily: '"Baikal Book"',
                  fontSize: '14px',
                  backgroundColor: 'white'
                }}
              >
                <option value="">No school</option>
                {(schools || []).map(s => (
                  <option key={s.id} value={s.id}>{s.name}</option>
                ))}
              </select>
              {errors.active_school && (
                <div style={{ marginTop: '6px', color: '#ef4444', fontSize: '12px', fontFamily: '"Baikal Book"' }}>
                  {Array.isArray(errors.active_school) ? errors.active_school.join(', ') : errors.active_school}
                </div>
              )}
            </div>
            )}

            <div>
              <label style={{ display: 'block', fontSize: '13px', fontFamily: '"Baikal Book"', fontWeight: 700, marginBottom: '6px' }}>
                City
              </label>
              <input
                name="city"
                value={form.city}
                onChange={onChange}
                style={{
                  width: '100%',
                  padding: '12px 12px',
                  border: `1px solid ${errors.city ? '#ef4444' : '#e5e7eb'}`,
                  borderRadius: '10px',
                  fontFamily: '"Baikal Book"',
                  fontSize: '14px'
                }}
              />
              {errors.city && (
                <div style={{ marginTop: '6px', color: '#ef4444', fontSize: '12px', fontFamily: '"Baikal Book"' }}>
                  {Array.isArray(errors.city) ? errors.city.join(', ') : errors.city}
                </div>
              )}
            </div>

            <div>
              <label style={{ display: 'block', fontSize: '13px', fontFamily: '"Baikal Book"', fontWeight: 700, marginBottom: '6px' }}>
                State
              </label>
              <input
                name="state"
                value={form.state}
                onChange={onChange}
                style={{
                  width: '100%',
                  padding: '12px 12px',
                  border: `1px solid ${errors.state ? '#ef4444' : '#e5e7eb'}`,
                  borderRadius: '10px',
                  fontFamily: '"Baikal Book"',
                  fontSize: '14px'
                }}
              />
              {errors.state && (
                <div style={{ marginTop: '6px', color: '#ef4444', fontSize: '12px', fontFamily: '"Baikal Book"' }}>
                  {Array.isArray(errors.state) ? errors.state.join(', ') : errors.state}
                </div>
              )}
            </div>

            <div style={{ gridColumn: '1 / -1' }}>
              <label style={{ display: 'block', fontSize: '13px', fontFamily: '"Baikal Book"', fontWeight: 700, marginBottom: '6px' }}>
                Phone number
              </label>
              <input
                name="phone_number"
                value={form.phone_number}
                onChange={onChange}
                style={{
                  width: '100%',
                  padding: '12px 12px',
                  border: `1px solid ${errors.phone_number ? '#ef4444' : '#e5e7eb'}`,
                  borderRadius: '10px',
                  fontFamily: '"Baikal Book"',
                  fontSize: '14px'
                }}
              />
              {errors.phone_number && (
                <div style={{ marginTop: '6px', color: '#ef4444', fontSize: '12px', fontFamily: '"Baikal Book"' }}>
                  {Array.isArray(errors.phone_number) ? errors.phone_number.join(', ') : errors.phone_number}
                </div>
              )}
            </div>

            <div style={{ gridColumn: '1 / -1', display: 'flex', alignItems: 'center', gap: '10px', marginTop: '4px' }}>
              <input
                id="edit_is_active"
                name="is_active"
                type="checkbox"
                checked={!!form.is_active}
                onChange={onChange}
              />
              <label htmlFor="edit_is_active" style={{ fontFamily: '"Baikal Book"', fontSize: '14px', color: '#111827' }}>
                Active
              </label>
            </div>
          </div>

          {errors.non_field_errors && (
            <div style={{ marginTop: '12px', color: '#ef4444', fontSize: '12px', fontFamily: '"Baikal Book"' }}>
              {Array.isArray(errors.non_field_errors) ? errors.non_field_errors.join(', ') : errors.non_field_errors}
            </div>
          )}

          {errors.error && (
            <div style={{ marginTop: '12px', color: '#ef4444', fontSize: '12px', fontFamily: '"Baikal Book"' }}>
              {errors.error}
            </div>
          )}

          <div style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '10px',
            marginTop: '18px',
            paddingTop: '14px',
            borderTop: '1px solid #e5e7eb'
          }}>
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              style={{
                padding: '12px 14px',
                borderRadius: '10px',
                border: '1px solid #e5e7eb',
                backgroundColor: 'white',
                cursor: loading ? 'not-allowed' : 'pointer',
                fontFamily: '"Baikal Book"',
                fontSize: '14px',
                fontWeight: 700,
                color: '#111827',
                opacity: loading ? 0.7 : 1
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              style={{
                padding: '12px 14px',
                borderRadius: '10px',
                border: '1px solid #111827',
                backgroundColor: '#111827',
                color: 'white',
                cursor: loading ? 'not-allowed' : 'pointer',
                fontFamily: '"Baikal Book"',
                fontSize: '14px',
                fontWeight: 700,
                opacity: loading ? 0.85 : 1
              }}
            >
              {loading ? 'Saving...' : 'Save'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditUserModal;

